// utils/video.ts

export const isYouTube = (url?: string | null): boolean => !!url && (url.includes('youtube.com') || url.includes('youtu.be'));

export const getYouTubeEmbedUrl = (url?: string | null): string | null => {
	if (!url) return null;

	if (url.includes('youtu.be/')) {
		const id = url.split('youtu.be/')[1].split(/[?&]/)[0];
		return `https://www.youtube.com/embed/${id}?autoplay=1`;
	}

	const match = url.match(/[?&]v=([^&]+)/);
	if (match?.[1]) {
		return `https://www.youtube.com/embed/${match[1]}?autoplay=1`;
	}

	return null;
};

export const YOUTUBE_CONSENT_SRC_ATTRIBUTE = 'data-consent-src';

const IFRAME_TAG = /<iframe\b[^>]*>/gi;
// Leading whitespace keeps data-src from matching, and "=" keeps srcdoc from matching.
// The value can be quoted or unquoted
const SRC_ATTRIBUTE = /(\s)src\s*=\s*(?:(["'])(.*?)\2|([^\s"'>]+))/i;
const YOUTUBE_URL = /^(https?:)?\/\/([\w-]+\.)*(youtube\.com|youtube-nocookie\.com|youtu\.be)\//i;

export const deferYouTubeIframes = (html: string): string => {
	if (!html) return html;

	return html.replace(IFRAME_TAG, (tag) =>
		tag.replace(SRC_ATTRIBUTE, (attribute, space, quote = '', quotedSrc, unquotedSrc) => {
			const src = quotedSrc ?? unquotedSrc;
			return YOUTUBE_URL.test(src) ? `${space}${YOUTUBE_CONSENT_SRC_ATTRIBUTE}=${quote}${src}${quote}` : attribute;
		}),
	);
};
